module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"head":{"meta":{"title":"編集記事一覧","description":"編集部\\n"}}}}')
  delete Component.options._Ctor
}
